import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  demoText: {
    fontSize: theme.fontSizes.default,
    color: theme.colors.textGrey
  },
  blueText: {
    cursor: 'pointer',
    color: theme.colors.navyBlue,
    textDecoration: 'none'
  }
}));

type Props = {
  children?: React.ReactNode;
};

function Footer({ children }: Props) {
  const classes = useStyles();
  return (
    <div className={classes.demoText}>
      Or contact{' '}
      <a className={classes.blueText} href="mailto:admin@ttc-hub.com">
        admin@ttc-hub.com
      </a>{' '}
      to book a demo
    </div>
  );
}

export default Footer;
